import React from "react";
import Script2Editor from "components/Script2Editor";

function Script2() {
  return (
    <div className=" pb-0">
      <Script2Editor />
    </div>
  );
}

export default Script2;
